

































import { defineComponent } from '@vue/composition-api';

import DeliveryTimeStats from '@/components/Report/04-DeliveryTime/DeliveryTimeStats.vue';
import LineChartWithLastYearCompare from '@/components/Report/04-DeliveryTime/LineChartWithLastYearCompare.vue';
import DeliveryTimeByHub from '@/components/Report/04-DeliveryTime/DeliveryTimeByHub.vue';
import DeliveryTimeByArea from '@/components/Report/04-DeliveryTime/DeliveryTimeByArea.vue';
import AverageDeliveryTimeByHub from '@/components/Report/04-DeliveryTime/AverageDeliveryTimeByHub.vue';
import AverageDeliveryTimeByArea from '@/components/Report/04-DeliveryTime/AverageDeliveryTimeByArea.vue';

const DeliveryTime = defineComponent({
  components: {
    DeliveryTimeStats,
    LineChartWithLastYearCompare,
    DeliveryTimeByHub,
    DeliveryTimeByArea,
    AverageDeliveryTimeByHub,
    AverageDeliveryTimeByArea,
  },
  setup() {
    return {};
  },
});

export default DeliveryTime;
